// extracted by mini-css-extract-plugin
export default {"wrapper":"Info_wrapper__E5cby","title":"Info_title__CfC0r","content":"Info_content__EmJoP"};